<template>
    <div class="set-up-page flex">
        <div class="preview">
            <img src="../../../temp/assets/MobilePreview.svg" alt="">
            <div class="mobile-screen">
                <div class="cover" v-if="!isCoverSelected"></div>

                <div class="uploaded-cover" v-if="isCoverSelected">
                    <img :src="coverPreview" alt="">
                </div>

                <div class="logo flex --font" v-if="!isLogoSelected">
                    Logo
                </div>

                <div class="logo flex --font" v-if="isLogoSelected">
                    <img class="" :src="logoPreview" alt="">
                </div>

                <div class="bottom-section flex">
                    <div class="content-section">
                        <h3 class="--font"> {{ brandDetails.name }} </h3>
                        <small class="secondary-font"> {{ brandDetails.description }} </small>
                    </div>
                    <div class="flex">
                        <img src="@/assets/FrontPage/LogoAndCover/globe.svg" alt="" class="mr-2">
                        <v-icon color="#419045">mdi-share-variant-outline</v-icon>
                    </div>
                </div>

                <div class="buttons flex">
                    <button class="white--text" style="background-color : #419045"> + Follow</button>
                    <button class="--blue" style="background-color : #E8EEF2">Send Message</button>
                    <button style="background-color : #E8EEF2; width : 20%;" class="flex"> 
                        <img src="@/assets/FrontPage/LogoAndCover/call.svg" alt="" style="width : 20px">
                    </button>
                 
                </div>
            </div>
        </div>

        <div class="upload-section">
            <upload-logo-or-cover ref="logoOrCoverPhotoRef" 
                                  @removeLogo="isLogoSelected = false" 
                                  @removeCover="isCoverSelected = false" 
                                  @logoURL="getLogoPreview"
                                  @coverURL="getCoverPreview"/>
        </div>
    </div>
</template>

<script>
import uploadLogoOrCover from './components/upload-logo__cover.vue';
export default {
    name : 'setupProfileLogo',

    data() {
        return {
            companyDetails : {
                heading : '',
                description : ''
            },
            logoPreview : null,
            coverPreview : null,
            isLogoSelected : false,
            isCoverSelected : false
        }
    },

    computed : {
        brandDetails() {
            return this.$store.getters['mainStore/GET_USER_DETAILS'].brand
        }
    },

    mounted() {
        if(this.$refs.logoOrCoverPhotoRef.logo) 
            this.isLogoSelected = true;
        
        if(this.$refs.logoOrCoverPhotoRef.cover) 
            this.isCoverSelected = true;
        
         if(this.$route.params.brandDetails) {
            this.getLogoPreview(this.$route.params.brandDetails.logo_image.original);
        }
    },

    methods : {
        getLogoPreview(URL) {
            console.log("I am fired");
            this.isLogoSelected = true;
            this.logoPreview = URL;
        },

        getCoverPreview(URL) {
            this.isCoverSelected = true;
            this.coverPreview = URL;
        }
    },

    components : {
        'upload-logo-or-cover' : uploadLogoOrCover,
    }
}
</script>

<style lang="scss" scoped>

.set-up-page {
    height: 100vh;
}

.preview {
    width: 35%;
    margin-right: 80px;
    position: relative;
    border-radius: 30px;
}

.preview img {
    position: relative;
    z-index: 1;
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.mobile-screen {
    width: 91%;
    margin-left: auto;
    margin-right: auto;
    left: 0;
    right: 0;
    position: absolute;
    top: 0;
    border-radius: 30px;
    padding-top: 10px;
}

.cover {
    border-top-left-radius: 30px;
    border-top-right-radius: 30px;
    height: 200px;
    width: 100%;
    background-color: #dfdfdf;

    img {
        width: 100%;
        height: 100%;
        border-top-left-radius: 30px;
        border-top-right-radius: 30px;
    }
}

.uploaded-cover {
    border-top-left-radius: 30px;
    border-top-right-radius: 30px;
    height: 200px;
    width: 100%;
    position: relative;
    z-index: 0;
}

.logo {
    width: 100px;
    height: 100px;
    background-color: #c4c4c4;
    border-radius: 50%;
    transform: translate(10px, -50px);

    img {
        width: 100%;
        height: 100%;
        border-radius: 50%;
    }
}

.bottom-section {
    padding: 0 15px;
    align-items: flex-start;
    justify-content: space-between;
    transform: translateY(-30px);
}

.buttons div{
    width: 31.33%;
}

.buttons {
    width: 95%;
    margin: auto;
    justify-content: space-between;
    padding-right: 9px;
}

.buttons button {
    width: 38%;
    background: red;
    font-weight: 500;
    padding: 10px 0;
    font-size: 0.85rem;
    border-radius: 3px;
}

.upload-section {
    width: 30%;
}

@media all and (min-width : 1400px) {
    .preview {
        width: 30%;
    }

    .upload-section {
        width: 20%;
    }
}

</style>









